import { useDispatch } from "react-redux";
import { RootDispatch } from "../../store";
import { useState } from "react";
import { addTaluka } from "../../store/slices/serviceManagementSlice";
import { getTalukasByDistrict } from "../../store/slices/kanbanSlice";
import Button, { ButtonType } from "../Assets/Button";

interface AddTalukaModalProps {
  isOpen: boolean;
  onClose: () => void;
  district: string;
}

const AddTalukaModal: React.FC<AddTalukaModalProps> = ({
  isOpen,
  onClose,
  district,
}) => {
  const dispatch = useDispatch<RootDispatch>();
  const [taluka, setTaluka] = useState("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleAdd = async () => {
    if (!taluka.trim()) return;

    setLoading(true);
    try {
      await dispatch(addTaluka({ district, taluka })).unwrap();
      await dispatch(getTalukasByDistrict(district));

      setLoading(false);
      setTaluka("");
      onClose();
    } catch (err) {
      setLoading(false);
      console.error("Failed to add taluka:", err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl w-[350px]">
        <h2 className="text-sm font-semibold mb-4">
          Add Taluka ({district.capitalizeWords()})
        </h2>

        <input
          value={taluka}
          onChange={(e) => setTaluka(e.target.value)}
          placeholder="Enter taluka name"
          className="w-full border p-2 rounded-md text-xs"
        />

        <div className="flex justify-end gap-2 mt-4">
          <Button
            onClick={onClose}
            type={ButtonType.Cancel}
            className="text-xs"
          >
            Cancel
          </Button>
          <Button
            type={ButtonType.Submit}
            onClick={handleAdd}
            disabled={loading}
            className="text-xs"
          >
            {loading ? "Adding..." : "Add"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddTalukaModal;
